export const REQUEST_BRAND_UPDATE_FAVOURITE_STATUS = 'REQUEST_BRAND_UPDATE_FAVOURITE_STATUS';

export const BRAND_UPDATE_FAVOURITE_STATUS = 'BRAND_UPDATE_FAVOURITE_STATUS';
export const BRAND_UPDATE_FAVOURITE_STATUS_PENDING = `${BRAND_UPDATE_FAVOURITE_STATUS}_PENDING`;
export const BRAND_UPDATE_FAVOURITE_STATUS_FULFILLED = `${BRAND_UPDATE_FAVOURITE_STATUS}_FULFILLED`;
export const BRAND_UPDATE_FAVOURITE_STATUS_REJECTED = `${BRAND_UPDATE_FAVOURITE_STATUS}_REJECTED`;

export const FETCH_FAVOURITED_BRANDS = 'FETCH_FAVOURITED_BRANDS';

export const requestUpdateBrandFavourite = (brandId, status) => ({
  type: REQUEST_BRAND_UPDATE_FAVOURITE_STATUS,
  payload: {
    brandId,
    status,
  },
});

export const updateBrandFavouriteActionCreator = (brandId, status, promise) => ({
  type: BRAND_UPDATE_FAVOURITE_STATUS,
  payload: promise,
  meta: {
    brandId,
    status,
  },
});

export const getFavouritedBrandsCreator = promise => ({
  type: FETCH_FAVOURITED_BRANDS,
  payload: promise,
});
